import { prefixObjectValues } from '../utils';

const form = {
  form: 'form',
  providerInvolvementSelect: 'provider-involvement-select',
  claimStatusSelect: 'claim-status-select',
  liabilityCarrierInput: 'liability-carrier-input',
  settlementAmtInput: 'settlement-amt-input',
  occurrenceDatePicker: 'occurence-date-picker',
  claimDatePicker: 'claim-date-picker',
  settlementDatePicker: 'settlement-date-picker',
  allegationsTxtInput: 'allegations-txt-input',
  allegedInjuryTxtInput: 'alleged-injury-txt-input',
  detailsTxtInput: 'details-txt-input',
  submitBtn: 'submit-btn',
  cancelBtn: 'cancel-btn',
};

export default prefixObjectValues(form, 'account-documents-form');
